import { useQuery } from '@tanstack/react-query'
import { queryKeys } from 'commons/hooks/services/queryKeys'
import { moneyPotService } from 'commons/services/moneyPotService'

const useMoneyPot = (slug: string) => {
	return useQuery({
		queryKey: queryKeys.moneyPot.getMoneyPotInfo(slug),
		queryFn: () => moneyPotService.getMoneyPotInfo(slug)
	})
}

export default useMoneyPot
